import React from "react";
import Dots from "../loaders/Dots";
import { Check } from "lucide-react";

export enum LookupStatus {
  Error = "error",
  Busy = "busy",
  Completed = "completed"
}

interface LookupStatusIndicatorProps {
  status: LookupStatus;
  label?: string;
  className?: string;
}

const LookupStatusIndicator: React.FC<LookupStatusIndicatorProps> = ({ status, label, className = "" }) => {
  if (status === LookupStatus.Busy) {
    return <Dots />;
  }

  if (status === LookupStatus.Completed) {
    return (
      <div className={`flex items-center gap-1 text-green-600 ${className}`}>
        <Check className="h-4 w-4" />
        {label && <span>{label}</span>}
      </div>
    );
  }

  const getStatusStyles = () => {
    switch (status) {
      case LookupStatus.Error:
        return "text-red-500";
      default:
        return "";
    }
  };

  const getDefaultLabel = () => {
    switch (status) {
      case LookupStatus.Error:
        return "Error";
      default:
        return "--";
    }
  };

  return (
    <span className={`${getStatusStyles()} ${className}`}>
      {label || getDefaultLabel()}
    </span>
  );
};

export default LookupStatusIndicator;